import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@/shared/components/Card';
import Collapse from '@/shared/components/Collapse';
import toast from 'react-hot-toast';
import { GlobalContext } from '../../../../../../context/GlobalContext';
import BookingBasicInfo from './BookingBasicInfo';
import { AuthContext } from '../../../../../../context/AuthContext';

const BookingInfo = ({ bookingID, id }) => {
    const [bookingDetails, setBookingData] = useState([]);
    const { apiGlobal } = useContext(GlobalContext);
    const { countryId } = useContext(AuthContext);
    // Fetch booking data from API
    const fetchBookingData = async () => {
        const formData = new FormData();
        formData.append('booking_id', bookingID);
        formData.append('id', id);
        formData.append('country_id', countryId);
        try {
            const url = await fetch(`${apiGlobal}/booking_payment_data.php`, {
                method: 'POST',
                body: formData,
            });
            const response = await url.json();
            
            if (response.status && response.message === 'Success') {
                // Extract and flatten all booking details
                const allBookingDetails = response.data.map(item => item.booking_details).flat();
                setBookingData(allBookingDetails);
            } else {
                toast.error('Failed to fetch booking data-in Booking Info');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (bookingID) {
            fetchBookingData();
        } else {
            toast.error('Booking Id Loading');
        }
    }, [bookingID, id]);

    // Group bookings by bookingDate (in camelCase)
    const groupedBookings = bookingDetails.reduce((acc, booking) => {
        const bookingDate = booking.booking_date; // API data in snake_case
        if (!acc[bookingDate]) {
            acc[bookingDate] = [];
        }
        acc[bookingDate].push(booking);
        return acc;
    }, {});

    const formatDate = (dateString) => {
        if (!dateString) return ''; // Handle empty values
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
      };

    return (
      <Col md={12}>
        <Card>
          <CardBody>
            {/* Render each group of bookings by bookingDate */}
            {Object.keys(groupedBookings).map(bookingDate => (
              <Collapse key={bookingDate} title={formatDate(bookingDate)} className="with-shadow">
                {/* For each date, display its bookings */}
                {groupedBookings[bookingDate].map(booking => (
                  <BookingBasicInfo key={booking.created_date_time} booking={booking} />
                            ))}
              </Collapse>
                    ))}
          </CardBody>
        </Card>
      </Col>
    );
};

BookingInfo.propTypes = {
    bookingID: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
};

export default BookingInfo;
